export default "__VITE_ASSET__ad0202bd__"